import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './add-works-dialog.styles'
import Button from 'pobble-components/dist/button'
import { Modal, ModalHeader, ModalContent } from 'pobble-components/dist/modal'

class AddWorksDialog extends Component {
  constructor(props) {
    super(props)
    this.state = { works: [] }
  }

  componentDidMount() {
    this.props.onMount(this.props.studentId).then(res => {
      this.setState({ works: res.data.account.student_type.works })
    })
  }
  render() {
    const {
      classes,
      isOpen,
      onClose,
      onAdd,
      assessmentFileId,
      studentName
    } = this.props

    let workList =
      this.state.works &&
      this.state.works.map(
        (work, index) =>
          work &&
          work.id && (
            <div className={classes.work} key={index}>
              <div className={classes.thumbnail}>
                <div>
                  <span
                    style={{
                      backgroundImage: `url("${work.media &&
                        work.media[0] &&
                        work.media[0].thumb_url}")`
                    }}
                  />
                </div>
              </div>
              <div className={classes.details}>
                {/*<div>
                  <h5 className={classes.title}>{work.title}</h5>
                  <span>{dateFns.format(work.updated_at, 'MM/DD/YYYY') || ''}</span>
                </div>*/}
                <Button
                  tall
                  className={classes.btn}
                  center
                  action={() =>
                    onAdd(work.id, assessmentFileId).then(() => onClose())
                  }
                  disabled={this.props.currentWorks.indexOf(work.id) > -1}>
                  {this.props.currentWorks.indexOf(work.id) > -1
                    ? 'Added'
                    : 'Add work'}
                </Button>
              </div>
            </div>
          )
      )

    return (
      <Modal closeButton requestClose={onClose} isOpen={isOpen} big>
        <ModalHeader>
          Add work from {studentName ? studentName + "'s" : ''} evidence bank
        </ModalHeader>
        <ModalContent legacy className={classes.content}>
          <div className={classes.upload}>
            <Button className={classes.uploadBtn} href="/actions/upload" tall>
              Upload work
            </Button>
          </div>
          <div className={classes.works}>{workList}</div>
        </ModalContent>
      </Modal>
    )
  }
}

export default injectSheet(styles)(AddWorksDialog)
